@use '../../styles/global' as *;
@use '../@shared/kol-link-mixin' as *;
@use '../@shared/mixins' as *;

@layer kol-component {
	@include kol-link-styles('kol-link');

	.kol-breadcrumb {
		&__list,
		&__list-element {
			display: flex;
			margin: 0;
			padding: 0;
			gap: 0.5em;
			flex-wrap: wrap;
			place-items: center;
			list-style: none;
		}

		&__list-element:first-child:last-child {
			min-height: var(--a11y-min-size);
		}
	}
}
